import React, {useEffect, useState} from "react";
import Modal from "../../hooks/modal";
import useModal from "../../hooks/useModal";
import {useStateValue} from "../../states/StateProvider";
import CompanyInfoPopUp from "../../components/modal/companyInfoPopUp";
import CompanyData from "./partial/companyData";
import Status from "./partial/status";
import Api from "../../Api/api";
import MilestoneTabs from "../../card/milestoneTabs";
import {ClipLoader} from "react-spinners";
import SubSteps from "./partial/subSteps";
import {useParams} from "react-router";
import {toast} from "react-toastify";
import {AES, enc} from "crypto-js";
import {useLocation, useNavigate} from "react-router-dom";
import CompanyInfoPopUpDGG from "../../components/modal/companyInfoPopUpDGG";
import CompanyInfoPopUpDGGEdit from "../../components/modal/companyInfoPopUpDGGEdit";
import CompanyInfoPopUpEdit from "../../components/modal/companyInfoPopUpEdit";

const Bestant = () => {
    const [{
        companyInfoModal,
        companyInfoEditModal,
        currentMilestone,
        noteSent,
        noteRows,
        remindersSaved,
        subStepSaved,
        secretKey,
        respChanged,
        upsellingSaved
    }, dispatch] = useStateValue();
    const {toggleCompanyInfoModal, toggleCompanyInfoEditModal} = useModal()
    const [userValidated, setUserValidated] = useState(false)
    const [loading, setLoading] = useState(true)
    const [loadingNotes, setLoadingNotes] = useState(false)
    const [stepsLoading, setStepsLoading] = useState(true)
    const [info, setInfo] = useState(null)
    const [infoLoading, setInfoLoading] = useState(false)
    const [notes, setNotes] = useState([])
    const [subSteps, setSubSteps] = useState([])
    const [filtered, setFiltered] = useState([])
    const [companyName, setCompanyName] = useState('')
    const [grid, setGrid] = useState([])
    const [milestoneTabs, setMilestoneTabs] = useState([])
    const [milestoneRoles, setMilestoneRoles] = useState({}) // Store role indicators for each milestone
    const [lastIndex, setLastIndex] = useState(null)
    const [lastDoneIndex, setLastDoneIndex] = useState(0)
    const [notesCount, setNotesCount] = useState(7)
    const [subString, setSubString] = useState(2)
    const [currentSubStep, setCurrentSubStep] = useState([])
    const [userCheckCompleted, setUserCheckCompleted] = useState(false)
    const param = useParams()
    const [options, setOptions] = useState([])
    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8))
    const role = user.role
    const navigate = useNavigate()
    const [showEdit, setShowEdit] = useState(false);
    const [{ansprechPartnerModalOpen}] = useStateValue();
    const prevModalOpen = usePrevious(ansprechPartnerModalOpen);
    const [hasUpselling, setHasUpselling] = useState(false);
    const [dataUpselling, setDataUpselling] = useState([]);

    function usePrevious(value) {
        const ref = React.useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    }

    useEffect(() => {
        if (respChanged && userCheckCompleted && userValidated) {
            // Modal just closed → refresh info
            setInfoLoading(true);
            Api().get(`/customerDetails/${param.portal}/${param.id}`).then(res => {
                setInfo(res.data[0]);
            }).catch(() => {
                toast.error('Firmendetails konnten nicht geladen werden!');
            }).finally(() => {
                setInfoLoading(false);
                dispatch({ type: "SET_RESP_CHANGED", item: false });
            });
        }
    }, [respChanged, userCheckCompleted, userValidated]);

    // Fetch upselling data
    useEffect(() => {
        if (userCheckCompleted && userValidated) {
            Api().get(`/sp_getDataCustUpselling/${param.portal}/${param.id}`).then(res => {
                if (res.data?.data && res.data?.data.length > 0) {
                    setHasUpselling(true);
                    const sortedOptions = res.data.data.sort((a, b) => {
                        return a.FP_ID - b.FP_ID;
                    });
                    setDataUpselling(sortedOptions[0]);
                } else {
                    setHasUpselling(false);
                    setDataUpselling([]);
                }
            }).catch(e => {
                console.error('Error fetching upselling data:', e);
            });
        }
    }, [userCheckCompleted, userValidated, param.portal, param.id, upsellingSaved]);

    useEffect(() => {
        let data = new FormData()
        data.append('user', user.ID)
        data.append('fp', param.id)
        data.append('portal', param.portal)
        Api().post(`/validateUserToFp`, data).then(res => {
            if (res.data === 1) {
                setUserValidated(true)
            } else {
                setUserValidated(false)
                toast.error('Sie besitzen für das FirmenProjekt kein Leserecht!')
                navigate('/support');
            }
            setLoading(true)
            setUserCheckCompleted(true)
        }).catch(e => {
            setUserValidated(false)
            setLoading(false)
            setUserCheckCompleted(true)
            toast.error('Sie besitzen für das FirmenProjekt kein Leserecht!')
        })
    }, []);

    useEffect(() => {
        if (userCheckCompleted && userValidated) {
            setSubSteps([])
            setOptions([])
        }
    }, [userCheckCompleted, currentMilestone]);

    useEffect(() => {
        if (userCheckCompleted && userValidated) {
            // let index = (Object.keys(milestoneTabs).length) - 1
            // let index = (Object.keys(milestoneTabs).length)
            setLastIndex(99)
        }
    }, [userCheckCompleted, milestoneTabs]);

    useEffect(() => {
        if (userCheckCompleted && userValidated) {
            Api().get(`/milestones/${param.portal}/${param.id}`).then(res => {
                setMilestoneTabs(res.data.tabs)
                setLastDoneIndex(res.data.done)
                setCompanyName(res.data.companyName)
                if (Number(res.data.done) !== (Object.keys(res.data.tabs).length) - 1) {
                    dispatch({type: "SET_CURRENTMILESTONE", item: Number(res.data.done) + 1})
                } else {
                    dispatch({type: "SET_CURRENTMILESTONE", item: Number(res.data.done)})
                }
                setLoading(false)
            }).catch(e => {
                setLoading(false)
                toast.error('Meilensteinschritte konnten nicht geladen werden!')
            })
        }
    }, [userCheckCompleted, dispatch, param.id, subStepSaved]);

    // Fetch role indicators for all milestones
    useEffect(() => {
        const fetchMilestoneRoles = async () => {
            if (userCheckCompleted && userValidated && milestoneTabs.length > 0) {
                const roles = {};

                for (const milestone of milestoneTabs) {
                    try {
                        const res = await Api().get(`/sub-steps/${param.portal}/${milestone.milestoneID}/${param.id}`);
                        const steps = res.data.subSteps;

                        if (steps && steps.length > 0) {
                            // Get the last step's responsible role
                            const lastStep = steps[steps.length - 1];
                            const responsible = lastStep.responsible?.toLowerCase();

                            if (responsible === 'aussendienst') {
                                roles[milestone.milestoneID] = 'A';
                            } else if (responsible === 'innendienst') {
                                roles[milestone.milestoneID] = 'I';
                            }
                        }
                    } catch (error) {
                        console.error(`Error fetching steps for milestone ${milestone.milestoneID}:`, error);
                    }
                }

                setMilestoneRoles(roles);
            }
        };

        fetchMilestoneRoles();
    }, [userCheckCompleted, userValidated, milestoneTabs, param.portal, param.id]);

    useEffect(() => {
        if (userCheckCompleted && userValidated) {
            setStepsLoading(true)
            setInfoLoading(true)
            Api().get(`/customerDetails/${param.portal}/${param.id}`).then(res => {
                setInfo(res.data[0])
            }).catch(e => {
                toast.error('Firmendetails konnten nicht geladen werden!')
            })
            setInfoLoading(false)
        }
    }, [userCheckCompleted]);

    useEffect(() => {
        if (userCheckCompleted && userValidated) {
            setStepsLoading(true)
            if (lastDoneIndex >= 0 && currentMilestone) {
                Api().get(`/sub-steps/${param.portal}/${currentMilestone}/${param.id}`).then(res => {
                    setSubSteps(res.data.subSteps)
                    let filter = res.data.subSteps.filter(d => d.fieldType === 'option')
                    setFiltered(filter)
                    if (filter.length === 0) {
                        setStepsLoading(false)
                    }

                    const unsaved = localStorage.data ? JSON.parse(localStorage.data) : []
                    if (unsaved?.length > 0) {
                        res.data.grid.map(r => {
                            unsaved?.map(u => {
                                if (currentMilestone === u.milestone && r.stepID === u.id && Number(param.id) === Number(u.firma) && user.ID === u.user) {
                                    const formatted = formatDate(u.value);
                                    if (u.type === 'date' && u.value !== null) {
                                        r.fieldValue = formatted
                                    } else {
                                        if (u.value !== null) {
                                            r.fieldValue = u.value
                                        }
                                    }
                                }
                            })
                        })
                    }
                    setGrid(res.data.grid)
                    // setNextStep(res.data.next)
                }).catch(e => {
                    setStepsLoading(false)
                    toast.error('Unterschritte konnten nicht geladen werden!')
                })
            }
        }
    }, [userCheckCompleted, lastDoneIndex, currentMilestone, param.id, subStepSaved]);

    useEffect(() => {
        if (userCheckCompleted && userValidated) {
            if (filtered.length > 0) {
                let data = new FormData()
                data.append('portal', param.portal)
                data.append('milestoneID', currentMilestone)
                data.append('subSteps', JSON.stringify(filtered))
                Api().post('/options', data).then(res => {
                    // Process options to add current grid values at the very beginning
                    // Backend returns array of arrays: [[options for substep1], [options for substep2], ...]
                    // We need to flatten it into a single array

                    // Flatten all substep option arrays into one flat array
                    let backendOptions = res.data.flat();

                    // Create a new array to hold grid values that need to be prepended
                    const optionsWithGridValues = [];

                    // For each substep that needs options, check if it has a grid value
                    filtered.forEach(substep => {
                        const gridItem = grid.find(g => g.stepID === substep.substepID);

                        if (gridItem && gridItem.fieldValue &&
                            gridItem.fieldValue !== null &&
                            gridItem.fieldValue !== '' &&
                            gridItem.fieldValue !== '0' &&
                            gridItem.fieldValue !== 'header') {

                            // Add grid value to the beginning array
                            optionsWithGridValues.push({
                                substepID: substep.substepID,
                                optionValue: gridItem.fieldValue
                            });

                            // Remove this value from backendOptions if it exists (to avoid duplicate)
                            backendOptions = backendOptions.filter(opt =>
                                !(opt.substepID === substep.substepID && opt.optionValue === gridItem.fieldValue)
                            );
                        }
                    });

                    // Combine: grid values FIRST, then all backend options (maintaining backend alphabetical order)
                    const finalOptions = [...optionsWithGridValues, ...backendOptions];

                    // Wrap in array to maintain expected structure: [[options]]
                    setOptions([finalOptions]);
                    setStepsLoading(false)
                }).catch(e => {
                    toast.error('Einige gespeicherte Werte konnten nicht geladen werden!')
                    setStepsLoading(false)
                })
            }
        }
    }, [userCheckCompleted, currentMilestone, filtered, grid]);

    useEffect(() => {
        if (userCheckCompleted && userValidated) {
            setLoadingNotes(true)
            Api().get(`/getNotes/${param.portal}/${param.id}/${noteRows}`).then(res => {
                setNotes(res.data)
                setNotesCount(res.data[0]?.total)
                setLoadingNotes(false)
            }).catch(e => {
                setLoadingNotes(false)
                toast.error('Notizen konnten nicht geladen werden!')
            })
        }
    }, [userCheckCompleted, noteRows, noteSent, remindersSaved]);

    useEffect(() => {
        if (userCheckCompleted && userValidated) {
            let arr = []
            if (filtered?.length > 0) {
                filtered.map(async (f, i) => {
                    arr.push(f.substepID)
                    setCurrentSubStep(arr)
                })
            }
        }
    }, [userCheckCompleted, currentMilestone, filtered]);

    useEffect(() => {
        if (userCheckCompleted && userValidated) {
            if (Number(currentMilestone) === lastIndex) {
                setSubString(0)
            } else {
                setSubString(2)
            }
        }
    }, [userCheckCompleted, currentMilestone, lastIndex, subString]);

    const formatDate = (input) => {
        const dt = new Date(input);
        if (!isNaN(dt)) {
            // Format the date as "yyyy-MM-dd"
            const year = dt.getFullYear();
            const month = String(dt.getMonth() + 1).padStart(2, '0');
            const day = String(dt.getDate()).padStart(2, '0');
            const formatted = `${year}-${month}-${day}`;
            return formatted;
        } else {
            return false;
        }
    };
    const style = {
        height: '55vh',
    };
    const styleEdit = {
        height: '100vh',
    };

    return (<div className='dashboardContainer'>
            <CompanyData info={info}
                         company={companyName}
                         companyID={param.id}
                         portal={param.portal}
                         loading={infoLoading}
                         toggle={toggleCompanyInfoModal}
                         toggleEdit={setShowEdit}
                         user={user}
            />

            <div className='lg:flex justify-between my-3 rounded-lg sm:block'>
                {loading ? <div style={{height: '30vh'}} className='centerItemsAbsolute bg-white w-11/12'>
                    <div className='mt-24'>
                        <ClipLoader size={50} color={'#888888'}/>
                    </div>
                </div> : <>
                    <div className='bg-white px-2 m-1 pb-10 lg:min-w-max lg:ml-0 rounded-lg h-fit'>
                        <h2 className='text-xl font-bold text-left py-5 px-2'>Projekt-Fortschritt</h2>
                        {milestoneTabs.map((tab, i) => (<MilestoneTabs
                                key={i}
                                id={tab.milestoneID}
                                label={tab.milestoneLabel}
                                loading={stepsLoading}
                                done={tab.milestoneDone}
                                lastIndex={lastIndex}
                                roleIndicator={milestoneRoles[tab.milestoneID] || ''}
                                abgesagt={info?.Status?.replace('Status:', '') === 'abgesagt'}
                            />))}
                    </div>

                    <div className='2xl:w-2/4 lg:ml-0 lg:w-5/12 h-fit text-left'>
                        <div className='bg-white p-5 my-1 mx-2 pb-10  rounded-lg'>
                            <SubSteps
                                data={subSteps}
                                loading={stepsLoading}
                                lastDoneIndex={lastDoneIndex}
                                options={options}
                                grid={grid}
                                lastIndex={lastIndex}
                                title={milestoneTabs.find(m => String(m.milestoneID) === String(currentMilestone))?.milestoneLabel.substring(subString)}
                                firma={param.id}
                                portal={param.portal}
                                milestone={currentMilestone}
                                hasUpselling={hasUpselling}
                                dataUpselling={dataUpselling}
                            />
                        </div>
                    </div>
                    <div className='bg-white mt-1 px-3 2xl:w-2/4 pb-10 lg:w-4/12 xl:ml-0 rounded-lg min-h-full'>
                        <Status company={companyName}
                                companyID={param.id}
                                portal={param.portal}
                                notes={notes}
                                role={role}
                                loadingNotes={loadingNotes}
                                count={notesCount}
                                showReminderSection={true}
                        />
                    </div>
                </>}
            </div>

            {param.portal === 'dgg' ?
                <CompanyInfoPopUpDGGEdit
                    portal={param.portal}
                    company={param.id}
                    companyName="Test GmbH"
                    show={showEdit}
                    toggle={setShowEdit}
                /> :
                <CompanyInfoPopUpEdit
                    portal={param.portal}
                    company={param.id}
                    companyName={companyName}
                    show={showEdit}
                    toggle={setShowEdit}
                />
            }
        </div>)
}

export default Bestant
